import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const Group1Icon = forwardRef<SVGSVGElement, IconProps>(function Group1Icon(
  { color, height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.951831 9.65645C0.898524 9.5269 0.857143 9.30725 0.857143 8.91667C0.857143 8.52608 0.898524 8.30644 0.951831 8.17688C0.991354 8.08083 1.04068 8.02115 1.1537 7.96011C1.29771 7.88233 1.55496 7.80041 2.01947 7.74465C2.4771 7.68972 3.07349 7.66667 3.85714 7.66667C4.6408 7.66667 5.23719 7.68972 5.69482 7.74465C6.15933 7.80041 6.41658 7.88233 6.56058 7.96011C6.6736 8.02115 6.72293 8.08083 6.76245 8.17688C6.81576 8.30644 6.85714 8.52608 6.85714 8.91667C6.85714 9.30725 6.81576 9.5269 6.76245 9.65645C6.72293 9.75251 6.6736 9.81218 6.56058 9.87323C6.41658 9.95101 6.15933 10.0329 5.69482 10.0887C5.23719 10.1436 4.6408 10.1667 3.85714 10.1667C3.07349 10.1667 2.4771 10.1436 2.01947 10.0887C1.55496 10.0329 1.29771 9.95101 1.1537 9.87323C1.04068 9.81218 0.991354 9.75251 0.951831 9.65645ZM3.85714 11C0.680786 11 0 10.6323 0 8.91667C0 7.20104 0.680786 6.83333 3.85714 6.83333C7.0335 6.83333 7.71429 7.20104 7.71429 8.91667C7.71429 10.6323 7.0335 11 3.85714 11Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.85714 5.16667C2.91037 5.16667 2.14286 4.42047 2.14286 3.5C2.14286 2.57953 2.91037 1.83333 3.85714 1.83333C4.80392 1.83333 5.57143 2.57953 5.57143 3.5C5.57143 4.42047 4.80392 5.16667 3.85714 5.16667ZM3.85714 6C2.43698 6 1.28571 4.88071 1.28571 3.5C1.28571 2.11929 2.43698 1 3.85714 1C5.2773 1 6.42857 2.11929 6.42857 3.5C6.42857 4.88071 5.2773 6 3.85714 6Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42857 3.91667C9.42857 2.88076 8.57835 1.83333 7.28571 1.83333C7.04902 1.83333 6.85714 2.01988 6.85714 2.25C6.85714 2.48012 7.04902 2.66667 7.28571 2.66667C8.05022 2.66667 8.57143 3.28591 8.57143 3.91667C8.57143 4.54742 8.05022 5.16667 7.28571 5.16667C7.04902 5.16667 6.85714 5.35321 6.85714 5.58333C6.85714 5.81345 7.04902 6 7.28571 6C8.57835 6 9.42857 4.95258 9.42857 3.91667Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71429 6.83333C7.71429 6.60321 7.90616 6.41667 8.14286 6.41667C9.38336 6.41667 10.3254 6.46367 10.9574 6.70619C11.2915 6.83441 11.568 7.02708 11.7532 7.31633C11.9348 7.6002 12 7.93297 12 8.29167C12 8.65173 11.9343 8.97382 11.7789 9.24799C11.6206 9.52735 11.3866 9.72583 11.1059 9.86226C10.5756 10.1201 9.84994 10.1667 9.05714 10.1667C8.82045 10.1667 8.62857 9.98012 8.62857 9.75C8.62857 9.51988 8.82045 9.33333 9.05714 9.33333C9.86435 9.33333 10.3958 9.27576 10.7226 9.11691C10.8705 9.04501 10.9652 8.95703 11.0282 8.84576C11.0942 8.72931 11.1429 8.55661 11.1429 8.29167C11.1429 8.02537 11.0937 7.86334 11.0254 7.75658C10.9605 7.65521 10.8514 7.56142 10.6426 7.48131C10.1889 7.30717 9.41664 7.25 8.14286 7.25C7.90616 7.25 7.71429 7.06345 7.71429 6.83333Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
